import { MkIcon } from "@/mk/MkIcon";
import type React from "react";
import { useTranslation } from "react-i18next";

import type { Workspace } from "@/api/workspace";

const OPTIONS: { value: Workspace; icon: string; label: string; title: string }[] = [
    { value: "consulting", icon: "fa-lightbulb-o", label: "workspace.consulting",
      title: "workspace.consultingTitle" },
    { value: "design", icon: "fa-pencil-square-o", label: "workspace.design", title: "workspace.design" },
    { value: "execution", icon: "fa-building", label: "workspace.execution", title: "workspace.execution" },
];

interface Props {
    value: Workspace;
    onChange(next: Workspace): void;
}

export function PmWorkspaceToggle({ value, onChange }: Props) {
    const { t } = useTranslation();
    return (
        <div className="pm-workspace">
            <span className="pm-workspace-caption">{t("workspace.caption")}</span>
            <div className={`pm-workspace-toggle is-${value}`} role="radiogroup"
                 aria-label={t("workspace.caption")}
                 style={{
                     "--pm-ws-count": OPTIONS.length,
                     "--pm-ws-index": Math.max(0, OPTIONS.findIndex((option) => option.value === value)),
                 } as React.CSSProperties}>
                <span className="pm-workspace-thumb" aria-hidden="true" />
                {OPTIONS.map((option) => (
                    <button key={option.value} type="button" role="radio"
                            aria-checked={value === option.value}
                            title={t(option.title)}
                            className={`pm-workspace-option${value === option.value ? " is-active" : ""}`}
                            onClick={() => onChange(option.value)}>
                        <MkIcon name={option.icon} />
                        <span className="pm-workspace-label">{t(option.label)}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
